import { useEffect, useState } from 'react'
import { collection, onSnapshot, query, where } from 'firebase/firestore'
import { db } from '../../../../firebase'
import { useNavigate } from 'react-router'
import Header from '../../Header/Header'
import '../premium/premium.css'

function Premium() {
  const [courses, setCourses] = useState([])
  const [search, setSearch] = useState('')

  useEffect(() => {
    const q = query(collection(db, 'courses'), where('type', '==', 'paid'))

    const unsub = onSnapshot(q, (snapshot) => {
      setCourses(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      )
    })

    return () => unsub()
  }, [])

  const navigate = useNavigate()

  const filteredCourses = courses.filter(
    (course) =>
      course.title?.toLowerCase().includes(search.toLowerCase()) ||
      course.description?.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <>
      <Header />

      <div>
        <h1 className="courses-tema">Платные курсы</h1>

        <input
          type="text"
          placeholder="Поиск платных курсов"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="premium-search-input"
        />

        {filteredCourses.length === 0 ? (
          <p>Ничего не найдено</p>
        ) : (
          <div className="courses-nav-details-container">
            {filteredCourses.map((course) => (
              <button
                className="courses-nav-details"
                key={course.id}
                onClick={() => navigate(`/premium/nav/${course.id}`)}
              >
                <h3>{course.title}</h3>
                <p>{course.description}</p>
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  )
}

export default Premium
